/** @flow */

export const employeeMessages = {
  en: {
    EMPLOYEE_CREATED: "Employee was successfully created",
    EMPLOYEE_UPDATED: "Employee was successfully updated",
    EMPLOYEE_ROLE_ADDED: "Employee Role was successfully added",
    EMPLOYEE_ROLE_UPDATED: "Employee Position was successfully updated",
    MEDICATION_ADDED: "Medication was successfully added",
    MEDICATION_UPDATED: "Medication was successfully updated",
    MEDICATION_REMOVED: "Medication was successfully removed",
    ALLERGY_ADDED: "Allergy was successfully added",
    ALLERGY_UPDATED: "Allergy was successfully updated",
    ALLERGY_REMOVED: "Allergy was successfully removed",
    HISTORY_ITEM_ADDED: "Medical History Item was successfully added",
    HISTORY_ITEM_REMOVED: "Medical History Item was successfully removed",
    ALERT_EXCLUSION_ADDED: "Employee Alert Exclusion was successfully added",
    ALERT_EXCLUSION_UPDATED: "Employee Alert Exclusion was successfully updated",
    ALERT_EXCLUSION_REMOVED: "Employee Alert Exclusion was successfully removed",
    USER_ACCOUNT_UPDATED: "User account successfully updated",
    USER_ACCESS_UPDATED: "User access was successfully updated",
    EMAIL_PASSWORD_INSTRUCTIONS_SENT:
      "Email with password reset instructions was successfully sent",
    AREA_OF_ACCESS_SUCCESSFULLY_UPDATED: "Area of Access was successfully updated",
    ABSENCE_NOTIFICATION_RESEND_SUCCESS: "Absence Notification was successfully resent",
    INVITATION_SENT_SUCCESSFULLY: "Invitation Sent Successfully",
  },
};

export default {
  en: {
    REPORTING_VIEW: "Reporting View",
    ABSENCE_MONITORING: "Absence Monitoring",
    ABSENCE_DETAILS: "Absence Details",
    ABSENCE_ADMIN: "Absence Admin",
    ABSENCE_DETAILS_WITH_NAME: "{name}: Absence Admin",
    ABSENCE_HISTORY: "Absence History",
    HISTORY: "History",
    ACTION_SUMMARY: "Action Summary",
    ACTIVE_ROLES: "Active Roles",
    ADD_NEW_ABSENCE: "Add New Absence",
    ADD_ABSENCE: "Add Absence",
    EDIT_ABSENCE: "Edit Absence",
    ADD_ROLE: "Add Role",
    EDIT_ROLE: "Edit Role",
    ALERT_NAME: "Alert Name",
    TOTAL_DOCUMENTS: "Total Documents",
    ACCEPTED_REFERRAL: "Accepted Referral",
    RTW_DATE_AT_REFERRAL: "RTW Date at Referral",
    GENERAL_DOCUMENTS: "General Documents",
    ABSENCE_SPECIFIC_DOCUMENTS: "Absence Specific Documents",
    TOTAL_FIT_NOTES: "Total Fit Notes",
    EMPLOYMENT_DETAILS: "Employment Details",
    EMPLOYMENT_DETAILS_WITH_NAME: "{name}: Employment Details",
    EMPLOYMENT_SUMMARY: "Employment Summary",
    CONTACT_DETAILS: "Contact Details",
    DATE_EXCLUDED: "Date Excluded",
    DISABLE_ALERTS: "Exclude An Employee From Alerts",
    EMPLOYEE_RECORD: "Employee Record",
    EXCLUDED_ALERTS: "Excluded Alerts",
    EXCLUDED_BY: "Excluded By",
    EXCLUDED_FROM: "Excluded From",
    EXCLUDED_TO: "Excluded To",
    PERSONAL_DETAILS: "Personal Details",
    PERSONAL_DETAILS_WITH_NAME: "{name}: Personal Details",
    EDIT_PERSONAL_DETAILS: "Edit Personal Details",
    ROLE_SUMMARY: "Role Summary",
    SECURITY_DETAILS: "Security Details",
    SPECIAL_CONTACT_ROLES: "Special Contact Roles",
    TOTAL_ACTIONS: "Total Actions",
    TOTAL_SALARY: "Total Salary",
    TOTAL_WEEKLY_CONTRACTED_HOURS: "Total Weekly Contracted Hours",
    TOTAL_WORKING_DAYS_YEAR: "Total Working Days/Year",
    EMPLOYEE_SEARCH: "Employee Search",
    SEARCH_CRITERIA: "Search Criteria",
    ADD_NEW_EMPLOYEE: "Add New Employee",
    SHOW_EMPLOYEE_RESULTS: "Showing {shownResults} of {totalResults} results",
    SHOW_EMPLOYEE_TOTAL:
      'Total Results: {total} (<strong>Active: {activeEmployees}</strong> <strong class="text-pumpkin-orange">Inactive: {inactiveEmployees}</strong>)',
    ADD_EMPLOYEE: "Add Employee",
    EDIT_EMPLOYEE: "Edit Employee",
    CONFIGURE_NOTIFICATION: "Configure Notification",
    CONFIGURE_CONTACT: "Configure Contact",
    SEARCH: "Search",
    SEARCH_RESULTS: "Search Results",
    EMPLOYEE_REF: "Employee Ref.",
    FIRST_NAME: "First Name",
    SURNAME: "Surname",
    DATE_OF_BIRTH: "Date of Birth",
    DEPARTMENT: "Department",
    DEPARTMENT_ABSENT_FROM: "Department Absent From",
    STATUS: "Status",
    EMPLOYEE_ID: "Employee ID",
    EMPLOYMENT_STATUS: "Employment Status",
    SELECT: "Select",
    COMPANY_NAME: "Company Name",
    MEDICAL_DETAILS: "Medical Details",
    MEDICAL_DETAILS_WITH_NAME: "{name}: Medical Details",
    MEDICATIONS: "Medications",
    MEDICATION: "Medication",
    MEDICAL_DETAILS_TABLE_TITLE_NOTES: "Notes",
    MEDICAL_DETAILS_TABLE_TITLE_STATUS: "Status",
    DATE_RECORDED: "Date Recorded",
    RECORDED_BY: "Recorded By",
    ASSOCIATED_ABSENCE: "Associated Absence",
    ACTION: "Action",
    ADD_NEW_MEDICATION: "Add New Medication",
    ADD_MEDICATION: "Add Medication",
    CANCEL: "Cancel",
    SAVE_ITEM: "Save Item",
    ALLERGY: "Allergy",
    ALLERGIES: "Allergies",
    ADD_NEW_ALLERGY: "Add New Allergy",
    ADD_ALLERGY: "Add Allergy",
    MEDICAL_HISTORY: "Medical History",
    TYPE: "Type",
    ITEM: "Item",
    ADDITIONAL_NOTES: "Additional Notes",
    ADD_NEW_ITEM: "Add New Item",
    ADD_ITEM: "Add Item",
    REMOVE_MEDICATION: "Remove Medication",
    REMOVE_CONFIRMATION: "Are you sure would like to remove {item} from this employee's record?",
    REMOVE_ALLERGY: "Remove Allergy",
    REMOVE_ITEM: "Remove Item",
    REPORT_NEW_ABSENCE: "Report New Absence",
    CHANGELOG_ITEM: "Change Log - {item}",
    CHANGELOG: "Change Log",
    CHOOSE_CLIENT: "Choose client",
    NOT_ASSOCIATED_ABSENCE: "Not associated to any absence",
    INVALID_DATE: "Invalid date",
    MY_DETAILS: "My Details",
    MY_INFORMATION: "My Information",
    CONTACT_INFO: "Contact Info",
    HOME_PAGE: "Home Page",
    CHANGE_PASSWORD: "Change Password",
    MY_ACCOUNT_DETAILS: "My Account Details",
    TITLE: "Title",
    DESCRIPTION: "Description",
    DATE_AVAILABLE: "Date Available",
    MY_ABSENCES: "My Absences",
    ABSENCE: "Absence",
    RTW_INTERVIEW: "RTW Interview",
    QUESTIONS_AND_ANSWERS: "Questions & Answers",
    QUESTION: "Question",
    QUESTION_ID: "Question ID",
    EMPLOYEE_RESPONSE: "Employee Response",
    DAY_TYPE: "Day Type",
    ROLE: "Role",
    TIME_DUE_TO_WORK: "Time Due To Work",
    HOURS_DUE_TO_WORK: "Hours Due To Work",
    HOURS_LOST: "Hours Lost",
    DAYS_LOST: "Days Lost",
    SPELLS: "Spells",
    referral_ID: "Referral Id",
    REFERRAL_REASON: "Referral Reason",
    DATE_TRIGGERED: "Date Triggered",
    WELLBEING_SUPPLIER: "Wellbeing Supplier",
    ALERT_ID: "Alert ID",
    JOB_TITLE: "Job title",
    POSITION_ID: "Position ID",
    POSITION_REF: "Position Ref",
    WEEKLY_CONTRACTED_HOURS: "Weekly Contracted Hours",
    DAYS_PER_YEAR: "Days Per Year",
    EFFECTIVE_FROM_DATE: "Effective From Date",
    EFFECTIVE_END_DATE: "Effective End Date",
    SALARY: "Salary",
    WORKING_DAYS_YEAR: "Working Days / Year",
    DATE_ASSIGNED: "Date assigned",
    ROLE_NAME: "Role Name",
    ASSIGNED_BY: "Assigned By",
    TOTAL_FTE: "Total FTE",
    FTE: "FTE",
    ABSENCES: "Absences",
    INTERACTIONS: "GoodShape Interactions",
    ADD_INTERACTION: "Add Interaction",
    ADVISOR: "Advisor",
    INTERACTION_NOTES: "Interaction Notes",
    EDIT_PATTERN: "Edit Pattern",
    NOTIFICATION_ID: "Notification ID",
    METHOD: "Method",
    RECIPENTS: "Recipients",
    CONSENT_TO_SHARE: "Consent to Share",
    DATE_CAPTURED: "Date Captured",
    ABSENCE_ID: "Absence ID",
    START: "Start",
    FIT_DATE: "FIt Date",
    RTW_DATE: "RTW Date",
    ABSENCE_REASON_CLASSIFICATION: "Absence Reason Classification",
    CONSENT_WITHHELD: "Consent Withheld",
    CONSENT_STATUS: "Consent Status",
    DATE_REPORTED: "Date Reported",
    DATE_CLOSED: "Date Closed",
    REPORTED_BY: "Reported By",
    USER_ACCOUNT_DETAILS: "User Account Details",
    USER_ACCOUNT_DETAILS_WITH_NAME: "{name}: User Account Details",
    UNLOCK_ACCOUNT: "Unlock Account",
    LOCKED_ACCOUNT_MESSAGE: "Account is locked.",
    ACCOUNT_DETAILS: "Account Details",
    ROLE_DETAILS: "Role Details",
    DATE_REGISTERED: "Date Registered",
    ACCOUNT_STATUS: "Account Status",
    ACCESS_LEVEL: "Access Level",
    ADVANCED_USER: "Advanced User",
    MANAGER: "Manager",
    CLIENT_SUPPLIER: "Supplier",
    RESET_PASSWORD: "Reset Password",
    AREA_OF_ACCESS: "Area of Access",
    AREA_OF_ACCESS_SUCCESSFULLY_UPDATED: "Area of Access was successfully updated",
    AREAS_INCLUDED: "Areas Included",
    AREAS_EXCLUDED: "Areas Excluded",
    UNIT_NAME: "Unit Name",
    SELECTED_AREAS: "Selected Areas",
    EXCLUDED_AREAS: "Excluded Areas",
    RECENT_LOGINS: "Recent Logins",
    SAVED_REPORTS: "Saved Reports",
    MANAGER_FOCUS_LIST: "Manager Focus List",
    ORGANISATIONAL_UNIT_FOCUS_LIST: "Organisational Unit Focus List",
    COMPLIANCE_TRENDS: "Compliance Trends",
    ABSENCE_REASON_TRENDS: "Absence Reason Trends",
    EMPLOYEE_FOCUS_LIST: "Employee Focus List",
    ABSENCE_RATE_TRENDS: "Absence Rate Trends",
    DATE_TIME: "Date and Time",
    IP_ADDRESS: "IP Address",
    BROWSER: "Browser",
    REFERRAL_ID: "Referral ID",
    RESULT: "Result",
    SELECT_AREAS: "Select Areas",
    FIND_DEPARTMENT: "Find Department",
    EVENT_DETAILS: "Event Details",
    ABSENCE_MONITORING_WITH_NAME: "{name}: Absence Monitoring",
    EMPLOYEES: "Employees",
    ACTIVITY_HISTORY: "Activity History",
    ACTIVITY_SUMMARY: "Activity Summary",
    ACTIVITY_HISTORY_ITEM_TITLE: "Activity #{id} - {type}",
    NOT_IN_PROCESS: "Not in Process",
    ACTIVITY_ID: "Activity ID",
    TASK_TYPE: "Task Type",
    ABSENCE_MONITORING_REVIEW: "Absence Monitoring Review",
    OVERDUE_TSKS: "Overdue Tasks",
    TASKS_STILL_WITHIN_KPI_TARGET: "Tasks Still Within KPI Target",
    WELLBEING_REFERRALS: "Wellbeing Referrals",
    ACTIVITY_DATE: "Activity Date",
    ACTIONED_BY: "Actioned By",
    LOG_SELF_REFERRAL: "Log Self Referral",
    MANUAL_REFERRAL: "Wellbeing Referral",
    REFERRALS: "Referrals",
    ABSENCE_MONITORING_REVIEWS: "Absence Monitoring Reviews",
    RTW_INTERVIEWS: "RTW Interviews",
    RTW_INTERVIEWS_TOOLTIP:
      "This is the number of RTW Interviews that have been completed in the last 24 hours. The table below will indicate whether each interview was done compliantly (i.e. on-time) or late.",
    DOCUMENTS: "Documents",
    ADD_DOCUMENT: "Add Document",
    SUPPROTED_FILE_TYPES: "Supported file types",
    SUPPROTED_FILE_TYPES_DESCRIPTION: ".pdf, .png, .jpeg, .txt, .jpg, .csv, .zip, .xml.",
    EDIT_DOCUMENT: "Edit Document",
    ADD_NOTE: "Add Note",
    SAVE_NOTE: "Save Note",
    ADD_MANAGER_NOTE: "Add Manager Note",
    EDIT_MANAGER_NOTE: "Edit Manager Note",
    DATE_UPLOADED: "Date Uploaded",
    UPLOADED_BY: "Uploaded By",
    DESELECT_ALL: "Deselect All",
    RELATED_ABSENCE_ID: "Related Absence ID",
    RECORD: "record",
    RECORDS: "record(s)",
    SELECTED: "selected",
    OUTSTANDING_TASKS: "outstanding tasks",
    MONITORING_UPDATE: "Monitoring Update",
    EMPLOYEE_NAME: "Employee Name",
    DATE_ABSENCE_REPORTED: "Date Absence Reported",
    ABSENCE_START_DATE_TIME: "Absence Start Date/Time",
    RTW_DATE_DATE_TIME: "RTW Date Date/Time",
    ORGANISATION_NAME: "Organisation Name",
    EMPLOYEMENT_INFO: "Employment Info",
    EMPLOYMENT_START: "Department",
    SERVICE_LENGTH: "Service Length",
    CONTRACTED_HOURS: "Contracted Hours",
    ANNUAL_WORKING_DAYS_AVAILABLE: "Annual Working Days Available",
    PRIMARY_EMAIL_ADDRESS: "Primary Email Address",
    SECONDARY_EMAIL_ADDRESS: "Secondary Email Address",
    PERSONAL_HOME_PHONE: "Personal Home Phone",
    HOME_PHONE: "Home Phone",
    MOBILE_PHONE: "Mobile Phone",
    PERSONAL_MOBILE_PHONE: "Personal Mobile Phone",
    WORK_PHONE: "Work Phone",
    WORK_PHONE_FOR_NOTIFICATIONS: "Work Phone for Notifications",
    PAGE_NUMBER: "Showing",
    PAGE_OF: "of",
    REMOVE_DOCUMENT_CONFIRMATION:
      "Are you sure would like to delete {documentName} from {employeeName} record?",
    REMOVE_DOCUMENT_MODAL_TITLE: "Remove Document",
    RETURN_TO_WORK_INTERVIEWS: "RTW Interviews",
    ALERT_TRIGGERED: "Alert Triggered",
    TASK_NOT_COMPLETED_YET: "Task not completed yet",
    EMPLOYEE_REFERRAL_DECISION: "Wellbeing Referral",
    MANAGER_REFERRAL_DECISION: "Wellbeing Referral",
    VIEW_ALERTS_TRIGGERED: "View Alerts Triggered",
    ASSIGNED_SHIFT_PATTERN: "Assigned Shift Pattern",
    ASSIGNED_SHIFT_PATTERNS: "Assigned Shift Patterns",
    GENDER: "Gender",
    MALE: "Male",
    FEMALE: "Female",
    HARD_OF_HEARING: "Hard of Hearing",
    DISABILITY: "Disability",
    SECONDARY_REF: "Secondary Ref",
    EMPLOYMENT_TYPE: "Employment Type",
    EMPLOYMENT_START_DATE: "Employment Start Date",
    EMPLOYMENT_END_DATE: "Employment End Date",
    SECURITY_QUESTION_FIELD: "Security Question",
    IS_NON_SERVICE: "Is Non Service",
    FIRSTCARE_ID: "GoodShape ID",
    NAME_OF_FIRST_SCHOOL: "Name of first school",
    NAME_OF_PET: "Name of pet",
    NAME_OF_BIRTH_PLACE: "Name of birth place",
    MOTHER_MAIDEN_NAME: "Mother's maiden name",
    NAME_OF_FIRST_COMPANY: "Name of first company",
    SOURCE: "Source",
    ABSENCE_MAIN_DETAILS: "Main Details",
    START_FIT_RTW_DATES: "Start-Fit-RTW Dates",
    RTW: "RTW",
    MORE_INFORMATION: "More Information",
    AUTHORISED: "Authorised",
    SICK_PAY_AUTHORISED: "Sick Pay Authorised",
    INTERACTION: "Interaction",
    WHL: "WHL",
    WDL: "WDL",
    CDL: "CDL",
    INTERVIEW_DETAILS: "Interview Details",
    INTERVIEW_DATE: "Interview Date",
    PERFORMED_BY: "Performed By",
    DETAILS: "Details",
    ADDED_ABSENCE_DETAILS: "Added {date} By {name}",
    WORK_RELATED_HEADER: "Work Related?",
    ACCIDENT_RELATED_HEADER: "Accident Related?",
    DATE_ABSENCE_CLOSED: "Date Absence Closed",
    LAST_ABSENT_DAY: "Last Absent Day",
    DATE_INTERVIEW_DUE: "Date Interview Due",
    COMPLETED_BY: "Completed By",
    TIME_TO_COMPLETE: "Time to Complete",
    COMPLIANT: "Compliant",
    COMPLETE_RTW_FORM: "Complete RTW Interview Form Now",
    CANCEL_RTW_FORM: "Cancel RTW Interview",
    FIRST_NAME_TOOLTIP_TEXT:
      "This is used in conjunction with Employee Ref and Date of Birth to help identify employees throughout the system.",
    SURNAME_TOOLTIP_TEXT:
      "This is used in conjunction with Employee Ref and Date of Birth to help identify employees throughout the system.",
    DOB_TOOLTIP_TEXT:
      "This is used in conjunction with Employee Ref and Surname to help identify employees. It is also used in the Age Group filter options on all reports.",
    HARD_OF_HEARING_TOOLTIP_TEXT:
      "This is used by GoodShape to flag hard of hearing employees on our system and to promote the use of the RNID TypeTalk service whenever these employees report absences",
    DISABILITY_TOOLTIP_TEXT:
      "This field is reference in alerts, which gives you the opportunity to exclude employees from the scope of an alert is their Disability status is set to Yes.",
    GENDER_TOOLTIP_TEXT: "This is used only for aggregated Gender Demographics report filters",
    SECURITY_QUESTION_TOOLTIP_TEXT:
      "This will be asked to your employee when they call to log an absence and part of the process through which we confirm their identity.",
    SECURITY_ANSWER_TOOLTIP_TEXT:
      "This is the answer that the employee must provide in order to verify their identify when contacting GoodShape.",
    EMPLOYEE_REF_TOOLTIP_TEXT:
      "This is used as a unique identifier for each employee to help GoodShape locate and access correct employee records",
    SECONDARY_REF_TOOLTIP_TEXT:
      "This is an entirely optional secondary reference number to help identify an employee.",
    ACTIVE_TOOLTIP_TEXT:
      "This defines if the employee record is active. If it is set to Inactive the employee will not be able to log into the system or report absences.",
    EMPLOYEE_TYPE_TOOLTIP_TEXT:
      "This defines the employment type for this record and will be used in the GoodShape Index Benchmarking reports.",
    EMPLOYMENT_START_DATE_TOOLTIP_TEXT:
      "This data is used to identify when an individual started working for the organisation. The employee will only contribute to absence reports from this date onwards.",
    EMPLOYMENT_END_DATE_TOOLTIP_TEXT:
      "This date is used to identify when an employee ceased to work at the organisation. Employees will not contribute to absence rates past this date. It must be greater than the Employment Start Date. When entered, the employment end date will automatically be applid to any active positions held by the employee.",
    FIRSTCARE_ID_TOOLTIP_TEXT:
      "This is the unique ID of the employee record as it sits on the GoodShape database.",
    MOBILE_PHONE_TOOLTIP_TEXT:
      "This is the personal mobile number of the employee and may be used by GoodShape to contact the employee, to identify their record when calling to record an absenceor invite them to use the Text to Close service.",
    PRIMARY_EMAIL_ADDRESS_TOOLTIP_TEXT:
      "This is the employee's work email address and is used for receiving absence notifications and logging into the Insight system.",
    SECONDARY_EMAIL_ADDRESS_TOOLTIP_TEXT:
      "This is the personal email address of the employee and is not used for notifications",
    WORK_PHONE_TOOLTIP_TEXT_1: "This if the work phone number of the employee. If ",
    WORK_PHONE_TOOLTIP_TEXT_2:
      " are enabled and this employee is a notification contact, it is to this phone number that the SMS notifications will be sent.",
    HOME_PHONE_TOOLTIP_TEXT:
      "This is the personal Landline/Home phone number of the employee and may be used by GoodShape to contact the employee or to identify their record when calling to record an absence.",
    NON_SERVICE_TOOLTIP_TEXT:
      "This defines if the employee record can be used to log absences (Service User) or if the record is in place for notifications/portal access but will not need to be used for logging absences (Non Service User). Non-Service records also do not contribute to Headcount totals or Absence Rate trends.",
    SMS_NOTIFICATION_TOOLTIP_LINK_TEXT: "SMS Notifications",

    POSITION_ID_TOOLTIP_TEXT: "This is the unique ID of the position on GoodShape's database.",
    EFFECTIVE_FROM_DATE_TOOLTIP_TEXT:
      "This data is used to identify when an employee started working in their role and, therefore, when they should contribute to absence reports for this position.",
    EFFECTIVE_END_DATE_TOOLTIP_TEXT:
      "This data is used to identify when an employee ceases working in the role and will no longer contribute to absence reports.",
    POSITION_REF_TOOLTIP_TEXT:
      "This  field is for adding a unique reference number for the position and is entirely optional if an employee only has one positon. If an employee has two or more positions then this value must be unique for each position.",
    JOB_TITLE_TOOLTIP_TEXT:
      'This field is used to display the employees job title in several reports throughout the system. If a Job Title is not supplied it will default to "Unassigned".',
    STAFF_GROUP_TOOLTIP_TEXT_1:
      "This is an optional field but its use is encouraged. Staff Groups present an opportunity to look at absence from a different perspective by comparing different occupations against each other. A Staff Group filter exists in most reports and the list of Staff Group types that appear on this drop down can be managed on the ",
    STAFF_GROUP_TOOLTIP_TEXT_2: " page in Service Admin.",
    STAFF_GROUP_TOOLTIP_LINK_TEXT: "Staff Group",
    DEPARTMENT_TOOLTIP_TEXT:
      "This field is used to assign an employees position to a department. Clicking on the field will open up the organisation's hierarchy, from which you will be able to select one department.",
    FTE_TOOLTIP_TEXT:
      "This data is used to create a Days Lost Per Full Time Equivalent (FTE) trend on the GoodShapeCentral portal. Any value between 0.00 and 1.00 can be entered.",
    WEEKLY_HOURS_TOOLTIP_TEXT:
      "This data is used to calculate the Hours Lost Absence % trend and is used to calculate the Hours Available side of the calculation. If this field is left blank a default of 37.5 hours will be used in reports.",
    DAYS_PER_YEAR_TOOLTIP_TEXT:
      "This data is used to calculate a Days Lost Absence % trend. If it is left blank a default of 228 will be used in reports.",
    ASSIGNED_SHIFT_PATTERN_TOOLTIP_TEXT_1:
      "This field presents a list of active Shift Patterns that have been configured in the ",
    ASSIGNED_SHIFT_PATTERN_TOOLTIP_TEXT_2:
      " section of Service Admin. One shift pattern can be assigned to each position. If a shift pattern is assigned, the employee will be asked to confirm it when reporting an absence and will no longer need to describe their day-by-day shift pattern during the call.",
    ASSIGNED_SHIFT_PATTERN_TOOLTIP_LINK_TEXT: "Shift Patterns",
    CURRENCY_CODE_TOOLTIP_TEXT:
      "This confirms the currency of the employees salary. At present the only option is GDP (£).",
    SALARY_TOOLTIP_TEXT_1:
      "This field is entirely optional and is presently not used in the system. The intention is for the field to be used to create a personalised cost of absence report. Presently all Cost of Absence reports used the Average Daily Cost of Absence value set in the ",
    SALARY_TOOLTIP_TEXT_2: " page.",
    SALARY_TOOLTIP_LINK_TEXT: "Reporting Parameters",
    USER_STATUS: "User Status",
    CURRENTLY_ABSENT: "Currently Absent?",
    PURE_CLOUD_INTERACTION_LINK: "Pure Cloud Interaction Link",
    INTERACTION_LINK: "Interaction Link",

    // NOTIFICATIONS
    NOTIFICATIONS: "Notifications",
    NOTIFICATIONS_SENT_TO: "Notifications Sent To",
    NOTIFICATIONS_SENT_TO_WITH_NAME: "{name}: Notifications Sent To",
    SENT_TO: "Sent To",
    NOTIFICATIONS_RECEIVED_FOR: "Notifications Received For",
    NOTIFICATIONS_RECEIVED_FOR_WITH_NAME: "{name}: Notifications Received For",
    RECEIVED_FOR: "Received For",
    NOTIFICATIONS_TO: "Notifications To",
    NOTIFICATIONS_FOR: "Notifications For",
    NOTIFICATIONS_SUMMARY: "Summary",
    NOTIFICATIONS_INDIVIDUAL_RECIPIENTS: "Individual Recipients",
    NOTIFICATIONS_INDIVIDUAL: "Individual Notifications",
    NOTIFICATIONS_ADD_RECIPIENT: "Add Recipient",
    NOTIFICATIONS_EDIT_RECIPIENT: "Edit Recipient",
    NOTIFICATIONS_DEPARTMENT_RECIPIENTS: "Department Recipients",
    NOTIFICATIONS_DEPARTMENT: "Department Notifications",
    NOTIFICATIONS_DEPARTMENT_CONTACT_ADMIN: "Department Contact Admin",
    NOTIFICATIONS_EMPLOYEE_REF: "Employee Ref",
    NOTIFICATIONS_EMPLOYEE_NAME: "Employee Name",
    NOTIFICATIONS_DEPARTMENT_REF: "Department Ref",
    NOTIFICATIONS_DEPARTMENT_NAME: "Department Name",
    NOTIFICATIONS_NOTIFICATION_TYPE: "Notification Type",
    NOTIFICATIONS_POSITION_SCOPE: "Position Scope",
    NOTIFICATIONS_DATE_ADDED: "Date Added",
    NOTIFICATIONS_ADDED_BY: "Added By",
    ALL_POSITIONS: "All Positions",
    TRANSFER: "Transfer",
    COPY: "Copy",
    DELETE_NOTIFICATION: "Delete Notification",
    DELETE_NOTIFICATION_CONFIRMATION: "Are you sure would like to delete {name} notification?",
    DELETE_NOTIFICATIONS_CONFIRMATION: "Are you sure would like to delete selected notifications?",
    NOTIFICATION_CONTACTS: "Notification Contacts",
    INDIVIDUAL_CONTACTS: "Individual Contacts",
    DEPARTMENTAL_CONTACTS: "Departmental Contacts",
    FULL_NOTIFICATION_CONTACTS: "Full Notification Contacts",
    STANDARD_CONTACTS: "Standard Contacts",
    NOTIFICATION_SCOPE: "Notification Scope",
    DEPARTMENT_ONLY: "Department Only",
    DEPARTMENT_AND_CHILDREN: "Department & Its Children",
    NON_MEDICAL_AUTHORISED: "Non-medical Authorised",
    SEARCH_DEPARTMENT: "Search Department",
    SELECT_DEPARTMENT: "Select Department",
    CONFIRM_RESET_PASSWORD_TEXT: "Are you sure would like to reset user's password?",
    DELETE_SPECIAL_CONTACT_ROLE: "Delete Special Contact Role",
    CONFIRM_DELETE_SPECIAL_CONTACT_ROLE: "Are you sure would like to delete special contact role?",
    WEEKLY_HOURS: "Weekly Hours",
    ACTIVE_POSITIONS: "Active Positions",
    POSITION_SCOPE: "Position Scope",
    DELETE_CONTACT: "Delete Contact",
    DELETE_CONTACT_CONFIRMATION: "Are you sure would like to delete {name} contact?",
    DELETE_CONTACTS_CONFIRMATION: "Are you sure would like to delete selected contacts?",
    EXCLUDE_AN_EMPLOYEE_FROM_ALERTS: "Exclude an employee from alerts",
    ADD_ALERT_EXCLUSION: "Add an Alert Exclusion",
    DATE_EXCLUDED_FROM: "Date Excluded From",
    DATE_EXCLUDED_TO: "Date Excluded To",
    REMOVE_ALERT_EXCLSUION_CONFIRMATION:
      "Are you sure would like to exclude the employee from {alertName} alert?",
    REMOVE_ALERT_EXCLSUION_MODAL_TITLE: "Remove alert exclusion",
    ADD_EXLUSION_ALERT_STEP_1_NEXT_BUTTON: "Next: Reason for Alert Exclusion",
    ADD_EXLUSION_ALERT_STEP_2_NEXT_BUTTON: "Save",
    CHOOSE_ALERT: "Choose Alert",
    REASON_FOR_ALERT_EXCLUSION: "Reason for exclusion",
    SPECIFY_ALERT_EXCLUSION: "Specify alert exclusion",
    SPECIFY_REASON_ALERT_EXCLUSION: "Specify Reason for Alert Exclusion",
    EDIT_ALERT_EXLUSION: "Edit Alert Exclusion",
    EXCLUSION_REASON: "Exclusion Reason",
    TRANSFER_NOTIFICATION: "Transfer Notification",
    TRANSFER_MULTIPLE_NOTIFICATIONS: "Transfer {number} Notifications",
    TRANSFER_NOTIFICATION_SUCCESS: "Notification was transfered successfully",
    TRANSFER_MULTIPLE_NOTIFICATIONS_SUCCESS: "{number} notifications were transfered successfully",
    COPY_NOTIFICATION: "Copy Notification",
    COPY_MULTIPLE_NOTIFICATIONS: "Copy {number} Notifications",
    COPY_NOTIFICATION_SUCCESS: "Notification was copied successfully",
    COPY_MULTIPLE_NOTIFICATIONS_SUCCESS: "{number} notifications were copied successfully",
    NOTES_TO_MANAGER: "Notes About This Absence",
    ABSENCE_REVISION_HISTORY: "Absence Revision History",
    INTERACTION_DATE: "Interaction Date",
    CONSENT_GIVEN: "Consent Given",
    ABSENCE_UPDATE: "Absence Update",
    ABSENCE_NOTIFICATION_NUMBER: "Absence Notification #{id}",
    CURRENT_LEVEL: "Current Level",
    ABSENCE_ALERT: "Absence alert",
    ABSENCE_CANCELLED: "Absence cancelled",
    ABSENCE_CLOSED: "Absence closed",
    BATCHED_NOTIFICATION: "Batched notification",
    CALLBACK_FAILURE: "Callback failure",
    LAUNCH_REGISTRATION_EMAIL: "Launch registration email",
    NEW_ALERT_INFORMATION: "New alert information",
    OPEN_OVERDUE_ABSENCE: "Open overdue absence",
    OVERDUE_RTW_REMINDER: "Overdue rtw reminder",
    PLANNED_LEAVE_CONFIRMATION: "Planned leave confirmation",
    RESTRICTED_CONTENT_EMAIL: "Restricted content email",
    RTW_NOTIFICATION: "Rtw notification",
    STANDARD_REGISTRATION_EMAIL: "Standard registration email",
    STARTED_AND_CLOSED_NOTIFICATION: "Started and closed notification",
    WELLBEING_ALERT: "Wellbeing alert",
    RTW_EXPIRY_TEXT:
      "The Return to Work Interview for this absence was not completed by the relevant line manager(s) and expired on {date}.",
    IMPERSONATE: "Impersonate",
    IMPERSONATE_CONFIRM: "Are you sure you want to login to the system as {name}?",
    IMPORTANT_NOTE: "Important Note: ",
    IMPERSONATE_NOTE:
      "In line with information security policies, a record of this action will be logged for auditing purposes.",
    PROCEED: "Proceed",
    EXPORT_FULL_ABSENCE_RECORD_FOR: "{name} : Export Full Absence Record",
    DOWNLOAD_REPORT: "Download Report",
    EXPORT_FULL_ABSENCE_RECORD_TITLE: "Confidential: {name} Absence Record",
    NO_ACCESS: "No Access",
    ALERT: "Alert",
    EMPLOYEE_SMS_MESSAGES: "Employee SMS Messages",
    VACCINATIONS: "Vaccinations",
    ADD_NEW_VACCINATION: "Add New Vaccination",
    ADD_VACCINATION: "Add Vaccination",
    DELETE_VACCINATION_TITLE: "Delete Vaccination",
    DELETE_VACCINATION_QUESTION:
      "Are you sure would like to remove {vaccinationName} from this employee's record?",
    DATE_VACCINATED: "Date Vaccinated",
  },
};
